import type { Firewall } from '@/entities/firewall';
import type { RequestMeta, ResponseMeta } from '@/shared/api';
import request from '@/shared/api/request';

export const getFirewalls = (
  params?: RequestMeta,
): Promise<{ firewalls: Firewall[]; meta: ResponseMeta }> =>
  request({
    url: '/firewalls/',
    params,
  });
